import {
  MODEL_ID,
  PROVIDER,
  ACTION,
  MODE,
} from 'Pods/ThreeDStudio/Store/constants'

export default {
  "model_id": MODEL_ID.TRIPO3D_RENDER_3D_TO_2D,
  "provider": PROVIDER.TRIPO3D,
  "action": ACTION.RENDER,
  "mode": MODE.NORMAL,
  "input_schema": {
    "type": "object",
    "properties": {
      "prompt": {
        "type": "string",
        "minLength": 1,
        "maxLength": 1024,
      },
      // The picked style's id. The Render tab stores the whole style card, so
      // getStoreValueForParam narrows it to the id before it reaches here.
      "style": {
        "type": "string",
        "minLength": 1,
        "maxLength": 255,
      },
      // PNG data URL of the model rendered as a depth map from the viewer's camera
      // pose. Produced per click by Services/renderDepthMap rather than held in the
      // form, so GenerateButton writes it into canonical_params after the build.
      "depth_map": {
        "type": "string",
      },
    },
    "required": [],
    "allOf": [
      // A render is driven by the prompt, the style, or both, so neither is
      // required - but an empty one is dropped rather than sent as "".
      {
        "if": {
          "properties": { "prompt": { "const": "" } },
          "required": ["prompt"],
        },
        "then": false,
      },
      {
        "if": {
          "properties": { "style": { "const": "" } },
          "required": ["style"],
        },
        "then": false,
      },
    ],
  },
  "ui_schema": {},
}
